<template>
	<div class="pop-livetalk-header">
    <h1>홈앤 &amp;tok</h1><!-- 2024-10-22 수정 -->
		<!--<span class="time">00:38:53</span>-->
    <clock ref="remainClock" :startTime="startTime" :endTime="endTime"></clock>
		<!-- <a href="#none" class="btn-close">닫기</a>-->
    <a href="hnsmallapp://webcontrol?action=typeViewClose" class="btn-close">X</a>
	</div>
</template>

<script>
import clock from '@/components/RemainClock'
import '@/styles/style.css';
export default {
  components: {
    clock,
  },
  data() {
    return {
      playingTime : "",
    }
  },
  methods: {
    // 채팅방을 닫고 앱으로 돌아간다.
    // 예전에는 남은시간이 0 이 되면 시계가 직접 호출했으나,
    // 지금은 관리자가 방송 종료를 지시했을 때(Chat.vue 의 closeRoom 수신)만 호출한다.
    leaveChat() {
      // console.log("leave")
      //window.location.href = "hnsmallapp://webcontrol?action=typeViewClose"
      window.open("hnsmallapp://webcontrol?action=typeViewClose", "_self");
    },
    startOnairTimer(){
      this.$refs.remainClock.startOnairTimer()
    }

  },
  props: ["startTime","endTime"]
}
</script>